/* eslint-disable @typescript-eslint/no-explicit-any */
import { KeplerGlLayers } from '@carto/kepler.gl/layers'
import { CHANNEL_SCALES, ALL_FIELD_TYPES } from '@carto/kepler.gl/constants'
import { HeatmapLayer as DeckGLHeatmapLayer } from '@deck.gl/aggregation-layers'
import IconHeatmap from 'assets/icons/layers/heatmap.svg?react'
import { KeplerLayerConfig, KeplerLayerVisConfig } from 'features/builder/types'

const heatmapVisConfigs = {
  opacity: 'opacity',
  colorRange: 'colorRange',
  colorAggregation: 'aggregation',
  radius: 'heatmapRadius'
}

// const dataFilterExtension = new DataFilterExtension({ filterSize: MAX_GPU_FILTERS })
const getWeightFunc = (dc, field: any) => (point: { index: number }) => dc.valueAt(point.index, field.fieldIdx)

export default class HeatMapLayer extends KeplerGlLayers.HexagonLayer {
  [x: string]: any

  declare config: (typeof KeplerGlLayers.HexagonLayer.prototype)['config'] & KeplerLayerConfig

  constructor(props: any) {
    super(props)
    this.registerVisConfig(heatmapVisConfigs)
  }

  get type() {
    return 'heatmap'
  }

  get name() {
    return 'Heatmap'
  }

  // @ts-expect-error TODO
  get layerIcon() {
    return IconHeatmap
  }

  // @ts-expect-error TODO
  get visualChannels() {
    return {
      weight: {
        property: 'weight',
        field: 'weightField',
        scale: 'weightScale',
        domain: 'weightDomain',
        key: 'weight',
        defaultMeasure: 'property.density',
        supportedFieldTypes: [ALL_FIELD_TYPES.real, ALL_FIELD_TYPES.integer],
        channelScaleType: CHANNEL_SCALES.sizeAggr
      }
    }
  }

  validateScale() {
    // Kepler is no ready to validate weight scale so we always return true
    return true
  }

  formatLayerData(datasets: any, oldLayerData: any) {
    const result = super.formatLayerData(datasets, oldLayerData)
    const { gpuFilter, dataContainer } = datasets[this.config.dataId]

    const getWeight = this.config.weightField ? getWeightFunc(dataContainer, this.config.weightField) : () => 1

    return {
      ...result,
      getWeight,
      getFilterValue: gpuFilter.filterValueAccessor()()
    }
  }

  renderLayer(opts: any) {
    const { data, gpuFilter } = opts
    const { visConfig } = this.config as { visConfig: KeplerLayerVisConfig }
    const updateTriggers = {
      getPosition: this.config.columns,
      getFilterValue: gpuFilter.filterValueUpdateTriggers,
      getWeight: {
        weightField: this.config.weightField
      }
    }

    return [
      new DeckGLHeatmapLayer({
        ...this.getDefaultDeckLayerProps(opts),
        ...data,

        // radius
        radiusPixels: visConfig.radius,

        // color
        colorRange: this.getColorRange(visConfig.colorRange),
        colorScaleType: this.config.colorScale,
        colorAggregation: visConfig.colorAggregation,

        // updateTriggers
        updateTriggers,
        // extensions: [dataFilterExtension]
        extensions: []
      })
    ]
  }
}
